import { render } from "./ModuleInscriptionPage.vue?vue&type=template&id=0a922b62"
import script from "./ModuleInscriptionPage.vue?vue&type=script&lang=js"
export * from "./ModuleInscriptionPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__